import React, { useState, useContext, useCallback } from 'react';
import { LineChartLocalTrend } from 'src/types/site-local-trends';
import {
  SetNewChartsTypes,
  SiteLocalTrendsContextTypes,
  SiteLocalTrendsProviderPropsTypes,
} from './types';

const SiteLocalTrendsContext = React.createContext<SiteLocalTrendsContextTypes>(
  {} as SiteLocalTrendsContextTypes
);

export const useSiteLocalTrendsContext = () => useContext(SiteLocalTrendsContext);

const locaLineTrendChartsKey = 'localLineChart';
const initialState = JSON.parse(localStorage.getItem(locaLineTrendChartsKey)!) || [];

export const SiteLocalTrendsProvider = ({ children }: SiteLocalTrendsProviderPropsTypes) => {
  const [lineChartsLocalTrends, setLineChartsLocalTrends] =
    useState<LineChartLocalTrend[]>(initialState);

  const addNewChart = useCallback((chart: LineChartLocalTrend) => {
    setLineChartsLocalTrends((prevState) => {
      const updatedState = [...prevState, chart];
      localStorage.setItem(locaLineTrendChartsKey, JSON.stringify(updatedState));
      return updatedState;
    });
  }, []);

  const updateExitingChart = useCallback((updatedChart: LineChartLocalTrend) => {
    setLineChartsLocalTrends((prevState) => {
      const updatedState = prevState.map((item) =>
        item.id === updatedChart.id ? updatedChart : item
      );
      localStorage.setItem(locaLineTrendChartsKey, JSON.stringify(updatedState));
      return updatedState;
    });
  }, []);

  const removeChart = useCallback((chartId: string) => {
    setLineChartsLocalTrends((prevState) => {
      const updatedState = prevState.filter((chart) => chart.id !== chartId);
      localStorage.setItem(locaLineTrendChartsKey, JSON.stringify(updatedState));
      return updatedState;
    });
  }, []);

  const setNewCharts = useCallback(
    ({ charts, customerId, siteId }: SetNewChartsTypes) => {
      const filteredCharts = lineChartsLocalTrends.filter(
        (item) => item.customerId !== customerId || item.siteId !== siteId
      );
      const newChartState = [...filteredCharts, ...charts];
      setLineChartsLocalTrends(newChartState);
      localStorage.setItem(locaLineTrendChartsKey, JSON.stringify(newChartState));
    },
    [lineChartsLocalTrends]
  );

  return (
    <SiteLocalTrendsContext.Provider
      value={{
        addNewChart,
        removeChart,
        updateExitingChart,
        lineChartsLocalTrends,
        setNewCharts,
      }}
    >
      {children}
    </SiteLocalTrendsContext.Provider>
  );
};
